import {
    Pagination,
    PaginationContent,
    PaginationItem
} from "@workspace/web-ui/components/pagination";
import { cn } from "@workspace/web-ui/lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";


type PaginatorProps<T> = {
    items: T[];
    totalPages: number;
    currentPage: number;
    onPageChange: (value: React.SetStateAction<number>) => void;
    itemsPerPage: number;
    className?: string;
}

export function Paginator<T>({ items, totalPages, currentPage, onPageChange, itemsPerPage, className }: PaginatorProps<T>) {
    return (
        <div className={cn("flex items-center justify-between text-left mt-4 p-5 text-gray-600 text-sm border-t", className)}>
            <div className="flex-1">
                <span className=" text-[#464B55] text-sm font-normal inline-flex gap-1 ">
                    Showing <h6 className="text-[#1A202C] font-medium">{Math.min((currentPage - 1) * itemsPerPage + 1, items.length)}</h6> to{" "}
                    <h6 className="text-[#1A202C] font-medium">{Math.min(currentPage * itemsPerPage, items.length)}</h6>  of <h6 className="text-[#1A202C] font-medium">{items.length}</h6> Results
                </span>
            </div>
            <div className="flex items-center justify-end">
                <Pagination>
                    <PaginationContent>
                        <PaginationItem className="border rounded-md p-1 cursor-pointer">
                            <ChevronLeft onClick={() => onPageChange((prev) => Math.max(prev - 1, 1))}
                                className={`${currentPage === 1 ? "opacity-50 pointer-events-none" : ""} `}
                            />
                        </PaginationItem>
                        <PaginationItem className="border rounded-md p-1 cursor-pointer">
                            <ChevronRight
                                onClick={() => onPageChange((prev) => Math.min(prev + 1, totalPages))}
                                className={`${currentPage === totalPages ? "opacity-50 pointer-events-none" : ""} `}
                            />
                        </PaginationItem>
                    </PaginationContent>
                </Pagination>
            </div>
        </div>
    )
}
